const ClientLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
};

const SessionDuration = {
  TEN: 'TEN',
  FIFTEEN: 'FIFTEEN',
  TWENTY: 'TWENTY',
  THIRTY: 'THIRTY',
  FORTY: 'FORTY',
  FORTY_FIVE: 'FORTY_FIVE',
  FIFTY: 'FIFTY',
  SIXTY: 'SIXTY',
  NINETY: 'NINETY',
};

const ExerciseFormat = {
  INDIVIDUAL: 'INDIVIDUAL',
  CIRCUITS: 'CIRCUITS',
};

const PerformedLocation = {
  HOME: 'HOME',
  GYM: 'GYM',
  OUTDOORS: 'OUTDOORS',
};

const IntensityLevel = {
  LOW: 'LOW',
  MODERATE: 'MODERATE',
  HIGH: 'HIGH',
};

const GenerationConfig = {
  ClientLevel: 'CLIENT_LEVEL',
  SessionDuration: 'SESSION_DURATION',
  PerformedLocation: 'PERFORMED_LOCATION',
  IntensityLevel: 'INTENSITY_LEVEL',
  ExerciseFormat: 'EXERCISE_FORMAT',
  WorkoutStyle: 'WORKOUT_STYLE',
  FocusAreas: 'FOCUS_AREAS',
  AccessibleEquipment: 'ACCESSIBLE_EQUIPMENT',
  Limitations: 'LIMITATIONS',
};

const ClientLevelOptions = [
  { value: ClientLevel.BEGINNER, label: 'Beginner' },
  { value: ClientLevel.INTERMEDIATE, label: 'Intermediate' },
  { value: ClientLevel.ADVANCED, label: 'Advanced' },
];

const SessionDurationOptions = [
  { value: SessionDuration.TEN, label: '10 minutes' },
  { value: SessionDuration.FIFTEEN, label: '15 minutes' },
  { value: SessionDuration.TWENTY, label: '20 minutes' },
  { value: SessionDuration.THIRTY, label: '30 minutes' },
  { value: SessionDuration.FORTY, label: '40 minutes' },
  { value: SessionDuration.FORTY_FIVE, label: '45 minutes' },
  { value: SessionDuration.FIFTY, label: '50 minutes' },
  { value: SessionDuration.SIXTY, label: '1 hour' },
  { value: SessionDuration.NINETY, label: '1 hour 30 minutes' },
];

const ExerciseFormatOptions = [
  { value: ExerciseFormat.INDIVIDUAL, label: 'Single exercise circuits' },
  { value: ExerciseFormat.CIRCUITS, label: 'Multi-exercise circuits (Supersets)' },
];

const PerformedLocationOptions = [
  { value: PerformedLocation.HOME, label: 'Home' },
  { value: PerformedLocation.GYM, label: 'Gym' },
  { value: PerformedLocation.OUTDOORS, label: 'Outdoors' },
];

const IntensityLevelOptions = [
  { value: IntensityLevel.LOW, label: 'Low' },
  { value: IntensityLevel.MODERATE, label: 'Moderate' },
  { value: IntensityLevel.HIGH, label: 'High' },
];

const GenerationConfigOptions = {
  [GenerationConfig.ClientLevel]: ClientLevelOptions,
  [GenerationConfig.SessionDuration]: SessionDurationOptions,
  [GenerationConfig.PerformedLocation]: PerformedLocationOptions,
  [GenerationConfig.ExerciseFormat]: ExerciseFormatOptions,
  [GenerationConfig.IntensityLevel]: IntensityLevelOptions,
};

const DropdownGenerationConfig = [
  GenerationConfig.ClientLevel,
  GenerationConfig.SessionDuration,
  GenerationConfig.PerformedLocation,
  GenerationConfig.IntensityLevel,
  GenerationConfig.ExerciseFormat,
];

const TextGenerationConfig = [
  GenerationConfig.WorkoutStyle,
  GenerationConfig.FocusAreas,
  GenerationConfig.AccessibleEquipment,
  GenerationConfig.Limitations,
];

const GenerationConfigDefaults = {
  [GenerationConfig.ClientLevel]: ClientLevel.BEGINNER,
  [GenerationConfig.SessionDuration]: SessionDuration.THIRTY,
  [GenerationConfig.PerformedLocation]: PerformedLocation.GYM,
  [GenerationConfig.IntensityLevel]: IntensityLevel.MODERATE,
  [GenerationConfig.ExerciseFormat]: ExerciseFormat.INDIVIDUAL,
  [GenerationConfig.WorkoutStyle]: '',
  [GenerationConfig.FocusAreas]: '',
  [GenerationConfig.AccessibleEquipment]: '',
  [GenerationConfig.Limitations]: '',
};

export {
  ClientLevel,
  SessionDuration,
  ExerciseFormat,
  PerformedLocation,
  IntensityLevel,
  GenerationConfig,
  DropdownGenerationConfig,
  TextGenerationConfig,
  GenerationConfigDefaults,
  GenerationConfigOptions,
  ClientLevelOptions,
  SessionDurationOptions,
  ExerciseFormatOptions,
  PerformedLocationOptions,
  IntensityLevelOptions,
};
